import { useCallback } from 'react';
import { useSweepApi } from '../sweep';
import { BestPractice, CreateBestPractice } from '../../components/bestPractices/types';

export const useBestPracticesApiFacade = () => {
  const sweepApi = useSweepApi();

  return {
    get_bestPractices: useCallback(async () => {
      const response = await sweepApi.get(`/best-practices`);
      return response.data as BestPractice[];
    }, [sweepApi]),

    post_bestPractice: useCallback(
      async (bestPractice: CreateBestPractice) => {
        const response = await sweepApi.post(`/best-practices`, bestPractice);
        return response.data as BestPractice;
      },
      [sweepApi],
    ),
    //update that doesn't require a re-scan
    patch_bestPractice: useCallback(
      async (id: string, bestPractice: Partial<Pick<BestPractice, 'severity'>>) => {
        const response = await sweepApi.patch(`/best-practices/${id}`, bestPractice);
        return response.data as BestPractice;
      },
      [sweepApi],
    ),

    delete_bestPractice: useCallback(
      async (id: string) => {
        const response = await sweepApi.delete(`/best-practices/${id}`);
        return response.data as BestPractice;
      },
      [sweepApi],
    ),
  };
};
